export const splitText = (
  content: string,
  firstChunkWords: number
): [string, string] => {
  const words = content.split(' ');
  const firstChunk = words.slice(0, firstChunkWords).join(' ');
  const secondChunk = words.slice(firstChunkWords).join(' ');

  return [firstChunk, secondChunk ? ` ${secondChunk}` : ''];
};
